import env from '../env';

export function GetGaUserCode(): string | null {
    try {
        const gaCookieMatch = document.cookie.match(/_ga=(.+?);/);
        if (gaCookieMatch && gaCookieMatch[1]) {
            const gaUserIdParts = gaCookieMatch[1].split(".").slice(-2);
            if (gaUserIdParts.length === 2) {
                return gaUserIdParts.join(".");
            }
        }
        return null;
    } catch (e) {
        return null;
    }
}

export function GetUserIdCookie(cookieName: string = "_ldat"): string {
    try {
        const name = `${cookieName}=`;
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookieArray = decodedCookie.split(';');
        for (let cookie of cookieArray) {
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.startsWith(name)) {
                const userIdParts = cookie.substring(name.length).split('.').slice(-2);
                if (userIdParts.length === 2) {
                    return userIdParts.join(".");
                }
                return "";
            }
        }
        return "";
    } catch (e) {
        return "";
    }
}


export function extrairDominioPai(): string {
    return env.REACT_APP_COOKIE_DOMAIN;
}
